import type { PartFileStandaloneViewerData } from '@frontend/api';

import type { ActionsOf } from 'store/types';

export const types = {
  INIT_FILE_VIEWER: 'modules/fileViewer/INIT_FILE_VIEWER',
  UPDATE_ITAR_STATUS: 'modules/fileViewer/UPDATE_ITAR_STATUS',
} as const;

type InitFileViewerPayload = {
  activeRootFile: PartFileStandaloneViewerData;
};

type UpdateItarStatusPayload = {
  isExportControlled: boolean;
};

export const fileViewer = {
  init: ({ activeRootFile }: InitFileViewerPayload) => ({
    type: types.INIT_FILE_VIEWER,
    payload: { activeRootFile },
  }),
  updateItarStatus: ({ isExportControlled }: UpdateItarStatusPayload) => ({
    type: types.UPDATE_ITAR_STATUS,
    payload: { isExportControlled },
  }),
};

export type FileViewerAction = ActionsOf<{
  init: typeof fileViewer.init;
  updateItarStatus: typeof fileViewer.updateItarStatus;
}>;
